// Path: ./src/app/components/FlyerGridList/styled.ts
import styled from "styled-components";
import { styled as MUiStyled, Pagination, Paper } from "@mui/material";
export const PaginationWrapper = styled.div`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`;

export const MuiPagination = MUiStyled(Pagination)({
  "& .MuiButtonBase-root.MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#fd954f",
    color: "white",
  },
});
export const ImageWrapper = styled.div<{ hasUsageHistory?: boolean }>`
  padding: 10px;
  box-shadow: 0px 0px 26px -2px
    ${(props) => (props.hasUsageHistory ? "#ff813a80" : "#cdcdcd")};
  border-radius: 8px;
  outline: none;
  text-decoration: none;
  border: ${(props) => (props.hasUsageHistory ? "2px solid #ff813a40" : "0px")};
  background: white;
  width: 100%;
  position: relative;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0px 0px 30px -2px
      ${(props) => (props.hasUsageHistory ? "#ff813a" : "#cdcdcd")};
    transform: ${(props) =>
      props.hasUsageHistory ? "translateY(-2px)" : "none"};
  }

  .tag-edit-btn {
    opacity: 0;
    transition: opacity 0.2s;
  }

  &:hover .tag-edit-btn {
    opacity: 1;
  }
`;

export const Image = styled.img`
  height: 136px;
  width: 136px;
  outline: none;
  text-decoration: none;
  border: 0px;
  background: white;
  object-fit: contain;
`;

export const Title = styled.div`
  font-size: 14px;
  font-family: system-ui;
  text-align: start;
  width: 100%;
  margin-top: 6px;
  overflow-wrap: break-word;
`;

export const ImageIcon = styled.div`
  position: absolute;
  top: 0.5rem;
  left: 0.3rem;
`;

export const Item = MUiStyled(Paper)(() => ({
  textAlign: "center",
  boxShadow: "none",
  width: "155px",
  margin: "auto",
  background: "transparent",
  cursor: "pointer",
  marginBottom: "15px",
}));
export const NoImageFoundWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  animation: appear 0.1s ease forwards 0.2s;

  @keyframes appear {
    to {
      opacity: 1;
      visibility: visible;
    }
  }
`;
export const HelperTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px;
  color: #a3a3a3;
`;

export const HelperText = styled.h4`
  text-align: center;
`;
